/**
 * Vehicle color type values
 */
export enum VehicleColorTypeEnum {
	EXTERIOR = 'exterior',
	INTERIOR = 'interior',
	ACCESSORY = 'accessory',
	RIM = 'rim',
}
